import { JsonObject, JsonProperty } from "ta-json";

import { OAuthGrantBase } from "./oauth-grant-base";
import { OAuthGrantType } from "./oauth-grant-type";

@JsonObject()
export default class OAuthClientCredentialsGrant extends OAuthGrantBase {
    @JsonProperty("grant_type")
    type: OAuthGrantType = OAuthGrantType.ClientCredentials;

    constructor(clientId: string, clientSecret: string) {
        super(clientId, clientSecret);
    }
}

export { OAuthClientCredentialsGrant };
